module.exports = __webpack_public_path__ + "static/img-featured-contributor-victoria-c86307d8be20bbf23599297b3dc2b9ae.jpg";